import { useParams } from 'react-router-dom'
import { Loading } from 'vnetwork-ui'
import Paper from '@/components/Paper'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import {
    getService,
    getServiceAddonConfigoptions,
    getServiceConfigoptions,
} from '@/modules/Service/services'
import ServiceEditForm from '@/modules/Service/components/shared/ServiceEditForm'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import OtherStandardConfig from '../../Templates/OtherStandard/Config'

// Config tab: edit the service + its addons configoptions inline within the
// service detail layout (shares the detail header + tab bar). Each service is
// saved independently (see ServiceEditForm/ConfigOptionEditor).
const Config = () => {
    const { id } = useParams()
    const serviceID = Number(id)

    const { data: service, renderState } = useQueryWithHandler({
        queryFn: () => getService(serviceID),
        queryKey: [QUERY_KEYS.SERVICE_DETAIL, serviceID],
    })
    const isOtherStandard =
        service?.service_template === 'Other.Standard' ||
        service?.product_group_code === 'OTHER'

    const { data: configoptions = [], isLoading: isConfigLoading } =
        useQueryWithHandler({
            queryKey: [QUERY_KEYS.SERVICES_CONFIGOPTIONS, serviceID],
            queryFn: () => getServiceConfigoptions({ serviceID }),
            enabled: !!serviceID && !!service && !isOtherStandard,
        })

    const { data: addons = [], isLoading: isAddonsLoading } =
        useQueryWithHandler({
            queryKey: [QUERY_KEYS.SERVICES, 'addons', serviceID],
            queryFn: () => getServiceAddonConfigoptions({ serviceID }),
            enabled: !!serviceID && !!service && !isOtherStandard,
        })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    if (!service) return null

    return (
        <Paper>
            {isOtherStandard ? (
                <OtherStandardConfig service={service} />
            ) : isConfigLoading || isAddonsLoading ? (
                <div className="flex justify-center py-8">
                    <Loading.CircularProgress width={30} height={30} />
                </div>
            ) : (
                <ServiceEditForm
                    service={service}
                    configoptions={configoptions}
                    addons={addons}
                />
            )}
        </Paper>
    )
}

export default Config
